import axios from "axios";
import React, { useState, useEffect } from "react";
import { useLocation } from "react-router-dom";
import { SERVER_URL } from "../../config/server";

function Otherprofilelink({ edit, data, token }) {
  const dept = useLocation().pathname.split("/")[2];

  // Helper function to extract link from any data type
  const extractLink = (personalLinkData) => {
    // If null/undefined/empty
    if (!personalLinkData) return "";
    
    // If it's a string
    if (typeof personalLinkData === "string") return personalLinkData;
    
    // If it's an array
    if (Array.isArray(personalLinkData)) {
      if (personalLinkData.length === 0) return "";
      
      const firstItem = personalLinkData[0];
      
      // If array contains objects with link property
      if (firstItem && typeof firstItem === "object" && firstItem.link) {
        return firstItem.link;
      }
      
      // If array contains strings
      if (typeof firstItem === "string") return firstItem;
      
      // If array contains objects without link property
      if (firstItem && typeof firstItem === "object") {
        // Try to find any string property that looks like a URL
        for (let key in firstItem) {
          if (typeof firstItem[key] === "string" && (firstItem[key].startsWith("http") || firstItem[key].includes("."))) {
            return firstItem[key];
          }
        }
      }
      
      return "";
    }
    
    // If it's an object (not array)
    if (typeof personalLinkData === "object") {
      // If object has link property
      if (personalLinkData.link) return personalLinkData.link;
      
      // If object has title and maybe URL in some other field
      for (let key in personalLinkData) {
        if (typeof personalLinkData[key] === "string" && (personalLinkData[key].startsWith("http") || personalLinkData[key].includes("."))) {
          return personalLinkData[key];
        }
      }
      
      return "";
    }
    
    return "";
  };

  const [link, setLink] = useState("");
  const [googlelink, setGooglelink] = useState("");

  useEffect(() => {
    // Extract and set personal link
    const extractedLink = extractLink(data?.personal_link?.["Personal Link"]);
    setLink(extractedLink);
    
    // Handle Google Scholar (assuming it's always a string)
    const googleData = data?.personal_link?.["Google Scholar Link"];
    if (typeof googleData === "string") {
      setGooglelink(googleData);
    } else if (Array.isArray(googleData) && googleData.length > 0) {
      // If Google Scholar is also an array sometimes
      setGooglelink(extractLink(googleData));
    } else {
      setGooglelink("");
    }
  }, [data]);

  const handleSubmit = async (e) => {
    e.preventDefault();

    try {
      // Ensure we're sending a clean string
      let personalLinkValue = link.trim();
      let googleLinkValue = googlelink.trim();

      const newRow = {
        "Personal Link": personalLinkValue,
        "Google Scholar Link": googleLinkValue,
      };

      console.log("Sending:", JSON.stringify(newRow, null, 2));

      const response = await axios.put(
        `${SERVER_URL}/dept/${dept}/Faculty/${data._id}/${token}?q=personal_link`,
        newRow
      );

      console.log(response.data);

      alert("✅ Links Updated Successfully");

      setTimeout(() => {
        window.location.reload();
      }, 500);
    } catch (error) {
      console.log(error);

      if (error.response) {
        alert(
          `❌ Error (${error.response.status}): ${
            error.response.data?.message ||
            "Failed to update"
          }`
        );
      } else if (error.request) {
        alert(
          "🌐 Network Error! Please check internet connection."
        );
      } else {
        alert(
          `❌ ${error.message || "Something went wrong"}`
        );
      }
    }
  };

  return (
    <div className="overflow-x-auto">
      {edit ? (
        <div className="m-4">
          <form
            className="w-full max-w-lg shadow-md border rounded p-3"
            onSubmit={handleSubmit}
          >
            {/* PERSONAL LINK */}
            <div className="mb-6">
              <label className="block uppercase tracking-wide text-sm font-bold mb-2">
                Personal Link
              </label>

              <input
                type="text"
                value={link}
                onChange={(e) => setLink(e.target.value)}
                placeholder="https://..."
                className="appearance-none bg-white py-2 px-3 block border w-full rounded-md border-gray-300 shadow-sm"
              />
            </div>

            {/* GOOGLE SCHOLAR LINK */}
            <div className="mb-6">
              <label className="block uppercase tracking-wide text-sm font-bold mb-2">
                Google Scholar Link
              </label>

              <input
                type="text"
                value={googlelink}
                onChange={(e) => setGooglelink(e.target.value)}
                placeholder="https://scholar.google.com/..."
                className="appearance-none bg-white py-2 px-3 block border w-full rounded-md border-gray-300 shadow-sm"
              />
            </div>

            {/* SUBMIT BUTTON */}
            <div className="flex justify-end">
              <button
                type="submit"
                className="relative inline-flex items-center justify-center p-0.5 overflow-hidden text-sm font-medium text-gray-900 rounded-lg group bg-gradient-to-br from-green-400 to-blue-600 active:translate-y-[2px] hover:shadow-xl"
              >
                <span className="relative px-5 py-2.5 transition-all ease-in duration-75 bg-white rounded-md">
                  Submit
                </span>
              </button>
            </div>
          </form>
        </div>
      ) : (
        <div className="overflow-x-auto relative my-2 scrollbar min-w-[570px]">
          <div className="flex max-w-full justify-between items-center p-4 shadow-md">
            <table className="text-sm sm:text-base">
              <tbody>
                {/* PERSONAL LINK */}
                {link && (
                  <tr>
                    <td className="font-bold pr-4 pl-2 py-2">
                      Personal Link
                    </td>

                    <td className="font-bold pr-4 pl-2 py-2">
                      :
                    </td>

                    <td>
                      <span
                        onClick={() => window.open(link, "_blank")}
                        className="text-orange-500 hover:underline cursor-pointer break-all"
                      >
                        {link}
                      </span>
                    </td>
                  </tr>
                )}

                {/* GOOGLE SCHOLAR */}
                {googlelink && (
                  <tr>
                    <td className="font-bold pr-4 pl-2 py-2">
                      Google Scholar Link
                    </td>

                    <td className="font-bold pr-4 pl-2 py-2">
                      :
                    </td>

                    <td>
                      <span
                        onClick={() => window.open(googlelink, "_blank")}
                        className="text-orange-500 hover:underline cursor-pointer break-all"
                      >
                        {googlelink}
                      </span>
                    </td>
                  </tr>
                )}
              </tbody>
            </table>
          </div>
        </div>
      )}
    </div>
  );
}

export default Otherprofilelink;